import { Icon } from "@pepperstone/pepper-ui-kit";
import { useTranslation } from "react-i18next";

import { AccountItem } from "../account-item/AccountItem";
import styles from "./MobileAccountSelectorTrigger.module.css";
import type { MobileAccountSelectorTriggerProps } from "./MobileAccountSelectorTrigger.types";

export const MobileAccountSelectorTrigger = ({
  selectedAccount,
  handleTriggerClick,
  "data-testid": testId,
}: MobileAccountSelectorTriggerProps) => {
  const { t } = useTranslation();

  const selectedAccountTestId = `${testId}-selected-account`;

  return (
    <button
      onClick={handleTriggerClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleTriggerClick();
        }
      }}
    >
      {selectedAccount ? (
        <AccountItem
          data-testid={selectedAccountTestId}
          preview
          account={selectedAccount}
          isMobile
        />
      ) : (
        <div className={styles["select-account"]}>
          <p>{t("deposit.accounts.select_account")}</p>
          <span className={styles["select-account-icon"]}>
            <Icon color="black" icon="arrow-right" size="tiny" />
          </span>
        </div>
      )}
    </button>
  );
};
